import {UtilisateurFamille} from '../connexion/models/utilisateur-famille.model';
import {ConnexionService} from '../connexion/connexion.service';
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ReferentielTelephone} from '../mon-compte/models/ReferentielTelephone.model';
import {UtilisateurGP} from '../mon-compte/models/utilisateurGP.model';
import {NumeroTelephoneValidator} from '../mon-compte/mes-notifications/numeroTelephone.validator';
import {ConfigProvider} from '../blocks/config/config.provider';
import {TutorielService} from '../tutoriel/tutoriel.service';
import {Subscription} from 'rxjs';
import {Principal} from '@app/core/auth/principal.service';
import {TranslateModule} from '@ngx-translate/core';
import {NgIf} from '@angular/common';
import {
    BtnIndicatifTelephoniqueComponent
} from "@shared/btn-indicatif-telephonique/btn-indicatif-telephonique.component";
import {focusFirstInvalidField} from "@shared/form/form.utils";

@Component({
    selector: 'ned-popin',
    templateUrl: './popin-connexion.component.html',
    styleUrls: ['./popin-connexion.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgbDropdownModule,
        BtnIndicatifTelephoniqueComponent,
    ],
})
export class PopinConnexionComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;

    etapeConnexion = 1;

    checkCgu = false;
    cguNotSelected = false;

    form: UntypedFormGroup | undefined;
    adresseMail: string | undefined;
    tailleNumeroPays: number | undefined;
    idIndicatifParDefaut: number | undefined;
    listeIndicatifs: ReferentielTelephone[] = [];
    utilisateurGP: UtilisateurGP | undefined;
    // l'index du tableau de la liste des indicatifs téléphoniques
    indexIndicatif: number | undefined;

    connectionSubscription: Subscription | undefined;

    urlVideoPermisVisite: string;
    urlVideoPermisVisiteMineur: string;
    urlVideoDemandePermisVisite: string;
    urlVideoRdvParloir: string;
    urlVideoNotificationRdvParloir: string;

    private opener: HTMLElement | null = null;
    private _resolver!: (value: boolean) => void;

    result: Promise<boolean> = new Promise(resolve => this._resolver = resolve);

    constructor(
        private connexionService: ConnexionService,
        private router: Router,
        private principal: Principal,
        private configProvider: ConfigProvider,
        private tutorielService: TutorielService,
    ) {
        this.urlVideoPermisVisite = this.configProvider.config.apiUrl + 'api/v1/tutoriel/video/permisVisite';
        this.urlVideoPermisVisiteMineur = this.configProvider.config.apiUrl + 'api/v1/tutoriel/video/permisVisiteMineur';
        this.urlVideoDemandePermisVisite = this.configProvider.config.apiUrl + 'api/v1/tutoriel/video/demandePermisVisite';
        this.urlVideoRdvParloir = this.configProvider.config.apiUrl + 'api/v1/tutoriel/video/rdvParloir';
        this.urlVideoNotificationRdvParloir = this.configProvider.config.apiUrl + 'api/v1/tutoriel/video/notificationRdvParloir';
    }

    ngOnInit() {
        this.listeIndicatifs.forEach((pays, indexPays) => {
            if (pays.refPictoPays === 'fr') {
                this.idIndicatifParDefaut = pays.id;
                this.indexIndicatif = indexPays;
            }
        });
        this.utilisateurGP && (this.utilisateurGP.idIndicatifTel = this.idIndicatifParDefaut!);

        this.tailleNumeroPays = this.listeIndicatifs[this.indexIndicatif!].lengthValidator;

        this.form = new UntypedFormGroup({
            adresseMail: new UntypedFormControl(this.adresseMail, [
                Validators.required,
                Validators.email,
                Validators.pattern('^[aA-zZ0-9._%+-]+@[aA-zZ0-9.-]+\\.[aA-zZ]{2,4}$')]),
            idIndicatifTel: new UntypedFormControl('', []),
            numeroTelephone: new UntypedFormControl('', [
                NumeroTelephoneValidator,
                Validators.minLength(this.tailleNumeroPays!),
                Validators.maxLength(this.tailleNumeroPays!)]),
        });
    }

    ngAfterViewInit() {
        // Désactive la fermeture de la modale avec Echap
        this.dialog.nativeElement.addEventListener('cancel', (e) => {
            e.preventDefault();
        });
    }

    ngOnDestroy(): void {
        this.tutorielService.isVideoLecture(false);
        this.connectionSubscription && this.connectionSubscription.unsubscribe();
    }

    open() {
        this.opener = document.activeElement as HTMLElement;

        const dlg = this.dialog.nativeElement;
        dlg.showModal();

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    close(value: boolean) {
        const dlg = this.dialog.nativeElement;
        dlg.close();

        this.opener?.focus();
        this._resolver(value);

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

    choixPaysNumero(indicatif: ReferentielTelephone, index: number) {
        this.utilisateurGP && (this.utilisateurGP.idIndicatifTel = indicatif.id);
        this.indexIndicatif = index;
        this.tailleNumeroPays = indicatif.lengthValidator;
        this.form && this.form.controls['numeroTelephone'].reset();

        if (this.tailleNumeroPays == null) {
            this.form && this.form.controls['numeroTelephone'].setValidators([
                NumeroTelephoneValidator]);
            this.tailleNumeroPays && (this.utilisateurGP!.longueurNumero = this.tailleNumeroPays);

        } else {
            this.form && this.form.controls['numeroTelephone'].setValidators([
                NumeroTelephoneValidator,
                Validators.minLength(this.tailleNumeroPays),
                Validators.maxLength(this.tailleNumeroPays)]);
        }
    }

    accepterCgu() {
        this.checkCgu = !this.checkCgu;
    }

    nextStep() {
        if (this.etapeConnexion === 1) {
            if (this.checkCgu) {
                this.etapeConnexion ++;
            } else {
                this.cguNotSelected = true;
            }
        } else if (this.etapeConnexion === 2) {
            if(this.form) {
                if (this.form.valid) {
                    this.etapeConnexion ++;
                } else {
                    this.form.markAllAsTouched();
                    focusFirstInvalidField(this.form.controls);
                }
            }
        }
    }

    // Enregistre les nouvelles informations de l'utilisateur à la fin de son parcours de 1ere connexion
    validerPremiereConnexion(goToTuto: boolean) {
        const utilisateurFamille = new UtilisateurFamille();
        // L'utilisateur est autorisé à saisir une adresse mail contenant des majuscules, elle est convertie en minuscules avant l'envoi au back
        utilisateurFamille.adresseMail = this.form && this.form.get('adresseMail')!.value.toLowerCase();
        utilisateurFamille.cguAcceptees = this.checkCgu;
        if (this.form && this.form.get('numeroTelephone')!.value !== '') {
            utilisateurFamille.idIndicatifTel = this.utilisateurGP!.idIndicatifTel;
            this.form && (utilisateurFamille.numeroTelephone = this.form.get('numeroTelephone')!.value);
        }
        this.connectionSubscription = this.connexionService.updateUtilisateurFamille(utilisateurFamille).subscribe(() => {
            this.close(true);
            this.principal.validatePremiereConnexion();

            if (goToTuto) {
                this.router.navigate(['/tutoriel']);
            } else {
                this.router.navigate(['']);
            }
        });
    }

    trackById(index: number, item: ReferentielTelephone) {
        return item.id;
    }

}
